import ApiClient from "@/libs/http-client";

// an Excel file of the CRM with the current filters
export function download(url, params, name) {
  return ApiClient.get(url, { params, responseType: "blob" }).then((response) => {
    if (!response) return;
    const link = document.createElement("a");
    link.href = URL.createObjectURL(response.data);
    link.download = name + "-" + new Date().toISOString().slice(0, 10) + ".xlsx";
    link.click();
    setTimeout(() => URL.revokeObjectURL(link.href), 1000);
  });
}
